var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _path31, _path32, _path33;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityReportsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 290.97,
    height: 216,
    viewBox: "0 0 290.97 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5429",
    "data-name": "Rectangle 5429",
    width: 290.97,
    height: 216,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5427",
    "data-name": "Rectangle 5427",
    width: 16.787,
    height: 6.243,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "ill_rapoarte",
    "data-name": "ill rapoarte",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9864",
    "data-name": "Group 9864",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9863",
    "data-name": "Group 9863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9862",
    "data-name": "Group 9862",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28596",
    "data-name": "Path 28596",
    d: "M262.829,199.208a58.65,58.65,0,0,0,2.74,16.208c.037.122.078.242.118.364h10.221c-.011-.109-.022-.231-.033-.364-.682-7.835,3.212-54.954,7.91-63.11-.411.665-21.749,22-20.956,46.9",
    transform: "translate(-255.594 -0.016)",
    fill: "#f5f5f5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28597",
    "data-name": "Path 28597",
    d: "M283.065,215.418c.086.122.174.244.265.364H291c-.058-.1-.125-.225-.2-.364-1.267-2.286-5.016-9.122-8.5-16.208-3.739-7.615-7.172-15.519-6.882-18.38-.09.645-2.679,20.317,7.648,34.588",
    transform: "translate(-275.064 -0.018)",
    fill: "#f5f5f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28598",
    "data-name": "Path 28598",
    d: "M200.721,44.576a5.338,5.338,0,0,1-7.789,2.52l-14.8,11.872-.916-9.817,14.2-9.768a5.367,5.367,0,0,1,9.31,5.193Z",
    transform: "translate(-87.36 -0.004)",
    fill: "#facca8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28599",
    "data-name": "Path 28599",
    d: "M188.756,48.219l5.523-3.9,6.265,7.239-7.288,4.32Z",
    transform: "translate(-98.311 -0.005)",
    fill: "#f5f5f5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28600",
    "data-name": "Path 28600",
    d: "M240.325,45.573,221.71,52.736,203.789,41A9.114,9.114,0,0,0,192.02,54.72l.16.178,27.561,14.776,30.1-13.754Z",
    transform: "translate(-148.539 -0.004)",
    fill: "#991f1f"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28601",
    "data-name": "Path 28601",
    d: "M16.7,215.4H190.8a9.965,9.965,0,0,0,9.952-10.475L194.739,87.521a9.965,9.965,0,0,0-9.952-9.456H167.045a9.962,9.962,0,0,0-5.719,1.8L138.484,95.879a9.962,9.962,0,0,1-5.719,1.8H10.86a9.966,9.966,0,0,0-9.948,10.56L6.754,206.03A9.966,9.966,0,0,0,16.7,215.4",
    transform: "translate(89.312 -0.008)",
    fill: "#e6e7eb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28602",
    "data-name": "Path 28602",
    d: "M86.77,173.955l112.115-46.171a1.6,1.6,0,0,0,.87-2.088L148.953,2.341a1.6,1.6,0,0,0-2.088-.87L34.75,47.642a1.6,1.6,0,0,0-.87,2.088l50.8,123.355a1.6,1.6,0,0,0,2.088.87",
    transform: "translate(57.34 0)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28603",
    "data-name": "Path 28603",
    d: "M86.77,173.955l112.115-46.171a1.6,1.6,0,0,0,.87-2.088L148.953,2.341a1.6,1.6,0,0,0-2.088-.87L34.75,47.642a1.6,1.6,0,0,0-.87,2.088l50.8,123.355a1.6,1.6,0,0,0,2.088.87M147.108,2.063a.961.961,0,0,1,1.253.522l50.8,123.354a.961.961,0,0,1-.522,1.253L86.526,173.363a.961.961,0,0,1-1.253-.522L34.472,49.486a.961.961,0,0,1,.522-1.253Z",
    transform: "translate(57.34 0)",
    fill: "#f5f5f5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28604",
    "data-name": "Path 28604",
    d: "M102.913,62.535,130.72,51.083A1.6,1.6,0,0,0,131.59,49L120.138,21.188a1.6,1.6,0,0,0-2.088-.87L90.243,31.77a1.6,1.6,0,0,0-.87,2.088l11.452,27.807a1.6,1.6,0,0,0,2.088.87m15.38-41.625a.961.961,0,0,1,1.253.522L131,49.239a.961.961,0,0,1-.522,1.253L102.67,61.944a.961.961,0,0,1-1.253-.522L89.965,33.615a.961.961,0,0,1,.522-1.253Z",
    transform: "translate(70.017 -0.002)",
    fill: "#a1a1b3"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28605",
    "data-name": "Path 28605",
    d: "M93.419,62.648,121.226,51.2a1.441,1.441,0,0,0,.783-1.88L110.557,21.509a1.441,1.441,0,0,0-1.88-.783L80.87,32.178a1.441,1.441,0,0,0-.783,1.88L91.539,61.865a1.441,1.441,0,0,0,1.88.783",
    transform: "translate(88.883 -0.002)",
    fill: "#991f1f"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28606",
    "data-name": "Path 28606",
    d: "M76.349,100.469l86.968-35.816a1.44,1.44,0,1,0-1.1-2.663L75.247,97.806a1.44,1.44,0,0,0,1.1,2.663Z",
    transform: "translate(52.412 -0.006)",
    fill: "#1d1d26"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28607",
    "data-name": "Path 28607",
    d: "M72.6,100.977,138.561,73.81a1.44,1.44,0,0,0-1.1-2.663L71.494,98.314a1.44,1.44,0,1,0,1.1,2.663Z",
    transform: "translate(80.922 -0.007)",
    fill: "#1d1d26"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28608",
    "data-name": "Path 28608",
    d: "M138.382,66.67l38.456-15.837a1.44,1.44,0,1,0-1.1-2.663L137.286,64.007a1.44,1.44,0,1,0,1.1,2.663Z",
    transform: "translate(-23.14 -0.005)",
    fill: "#1d1d26"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28609",
    "data-name": "Path 28609",
    d: "M134.624,71.872,163.483,59.99a1.44,1.44,0,0,0-1.1-2.663L133.524,69.212a1.44,1.44,0,0,0,1.1,2.663Z",
    transform: "translate(-6.023 -0.006)",
    fill: "#1d1d26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28610",
    "data-name": "Path 28610",
    d: "M68.807,118.767l86.97-35.816a1.44,1.44,0,0,0-1.1-2.663L67.707,116.1a1.44,1.44,0,0,0,1.1,2.663",
    transform: "translate(67.493 -0.008)",
    fill: "#1d1d26"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28611",
    "data-name": "Path 28611",
    d: "M65.05,119.276l65.966-27.165a1.44,1.44,0,1,0-1.1-2.663L63.949,116.615a1.44,1.44,0,0,0,1.1,2.663Z",
    transform: "translate(96.01 -0.009)",
    fill: "#1d1d26"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28612",
    "data-name": "Path 28612",
    d: "M61.268,137.063l86.97-35.816a1.44,1.44,0,0,0-1.1-2.663L60.168,134.4a1.44,1.44,0,0,0,1.1,2.663",
    transform: "translate(82.57 -0.01)",
    fill: "#1d1d26"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28613",
    "data-name": "Path 28613",
    d: "M57.5,146.212l86.97-35.816a1.44,1.44,0,0,0-1.1-2.663L56.4,143.549a1.44,1.44,0,0,0,1.1,2.663",
    transform: "translate(90.11 -0.011)",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28614",
    "data-name": "Path 28614",
    d: "M136.342,145.491a31.36,31.36,0,0,1-5.217-.159,11.281,11.281,0,0,1-4.551-1.253,4.325,4.325,0,0,1-2.155-3.271,3.043,3.043,0,0,1,1.842-3.086,3.63,3.63,0,0,1,3.684.516,4.8,4.8,0,0,1,1.647,3.832c-.072,2.963-2.416,5.889-5.019,7.122-2.932,1.388-6.936.209-7.687-3.21-.156-.711.812-.958,1.217-.5a3.229,3.229,0,0,1-4.506,4.609l1.09-.449a7.77,7.77,0,0,1-5.344,5.644,7.205,7.205,0,0,1-1.989.3,8.464,8.464,0,0,0-2.443.668l-5.643,1.839c-.83.271-1.357-.99-.52-1.262l5.11-1.665c.852-.277,1.7-.563,2.556-.833a15.217,15.217,0,0,1,1.916-.2,6.4,6.4,0,0,0,5-4.681.689.689,0,0,1,.791-.573.681.681,0,0,1,.3.124,1.869,1.869,0,1,0,2.6-2.686l1.217-.5c.484,2.206,3.175,3.033,5.113,2.4a7.746,7.746,0,0,0,4.679-4.962,4,4,0,0,0-.291-3.185,2.385,2.385,0,0,0-2.5-1.224,1.71,1.71,0,0,0-1.462,1.877,3.06,3.06,0,0,0,1.7,2.319,11.071,11.071,0,0,0,4.037.967,29.179,29.179,0,0,0,4.655.132c.871-.044,1.046,1.311.166,1.356Z",
    transform: "translate(53.742 -0.014)",
    fill: "#e6e7eb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28615",
    "data-name": "Path 28615",
    d: "M.37,117.237V205.11a10.3,10.3,0,0,0,10.3,10.3h173.38a10.3,10.3,0,0,0,10.3-10.3V97.618a10.3,10.3,0,0,0-10.3-10.3H167.239a10.3,10.3,0,0,0-5.91,1.865l-22.668,15.888a10.3,10.3,0,0,1-5.91,1.866H10.667a10.3,10.3,0,0,0-10.3,10.3",
    transform: "translate(96.256 -0.009)",
    fill: "#f5f5f5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28616",
    "data-name": "Path 28616",
    d: "M88.288,195.054H15.364a3.147,3.147,0,1,0,0,6.293H88.288a3.147,3.147,0,1,0,0-6.293",
    transform: "translate(187.32 -0.02)",
    fill: "#1d1d26"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28617",
    "data-name": "Path 28617",
    d: "M48.679,182.836H15.364a3.147,3.147,0,1,0,0,6.293H48.679a3.147,3.147,0,1,0,0-6.293",
    transform: "translate(226.929 -0.019)",
    fill: "#1d1d26"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28618",
    "data-name": "Path 28618",
    d: "M9.014,215.772h176.73a8.976,8.976,0,0,0,8.976-8.976V96.24a9.29,9.29,0,0,0-9.29-9.29H163.883l-28,19.619H10.1A10.1,10.1,0,0,0,0,116.67l.005,90.094a9.009,9.009,0,0,0,9.009,9.008M185,215.037H9.756a9.009,9.009,0,0,1-9.009-9.009v-88.7A10.016,10.016,0,0,1,10.763,107.31H136.121l27.991-19.62H185a8.981,8.981,0,0,1,8.981,8.981v109.39A8.976,8.976,0,0,1,185,215.037",
    transform: "translate(96.25 -0.009)",
    fill: "#f5f5f5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28619",
    "data-name": "Path 28619",
    d: "M254.218,202.69l6.563,2.346,12.171-24.2-9.687-3.462Z",
    transform: "translate(-236.174 -0.018)",
    fill: "#fdbf8f"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28620",
    "data-name": "Path 28620",
    d: "M276.286,216.02l.1-.268a8.758,8.758,0,0,0-5.293-11.182l-12.926-4.62-3.04,8.505Z",
    transform: "translate(-241.027 -0.02)",
    fill: "#1d1d26"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28621",
    "data-name": "Path 28621",
    d: "M220.072,209.182h6.97l3.316-26.884H220.071Z",
    transform: "translate(-159.436 -0.019)",
    fill: "#fdbf8f"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28622",
    "data-name": "Path 28622",
    d: "M209.661,215.942h22.475v-.284a8.748,8.748,0,0,0-8.748-8.747H209.66Z",
    transform: "translate(-150.804 -0.021)",
    fill: "#1d1d26"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28623",
    "data-name": "Path 28623",
    d: "M230.871,37.856l3.032-5.989s11.293,2.83,12.319,9.374Z",
    transform: "translate(-186.099 -0.003)",
    fill: "#f5f5f5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28624",
    "data-name": "Path 28624",
    d: "M228.953,105.9l8.243,46-21.889,38.709,13.078,5.115,22.173-37.523,2.843-10.234,1.706,53.442,11.793-.358,5.407-49.9-8.672-46.39Z",
    transform: "translate(-196.621 -0.011)",
    fill: "#1d1d26"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28625",
    "data-name": "Path 28625",
    d: "M224.613,85.443l.285-26.975c0-11.433,7.524-19.859,8.567-20.639a4.926,4.926,0,0,1,2.617-3.216c2.508-1.137,5.575.227,5.705.289l9.2,3.45.043.126c.1.289,9.383,30.758,11.714,38.4.332,1.1.523,1.725.523,1.725s-.036,1.768-.1,4.519c-.206,9.455-.693,30.516-.888,31.4,0,0-17,2.577-23.728,2.577a75.848,75.848,0,0,1-19.971-2.357l-.278-.058Z",
    transform: "translate(-190.576 -0.003)",
    fill: "#991f1f"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28626",
    "data-name": "Path 28626",
    d: "M239.676,6.616A12.441,12.441,0,1,0,244.625,23.5a12.441,12.441,0,0,0-4.949-16.883",
    transform: "translate(-176.425 -0.001)",
    fill: "#facca8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9861",
    "data-name": "Group 9861",
    transform: "translate(55.823 76.831)",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9860",
    "data-name": "Group 9860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9859",
    "data-name": "Group 9859",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28627",
    "data-name": "Path 28627",
    d: "M218.382,79.69l16.687,3.393c.065-2.75.1-4.519.1-4.519s-.191-.628-.523-1.725Z",
    transform: "translate(-218.382 -76.839)"
  }))))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28628",
    "data-name": "Path 28628",
    d: "M210.555,76.151a5.341,5.341,0,0,1-8.075-1.344l-18.6,3.737,3.7-9.138,17.1-2.148a5.367,5.367,0,0,1,5.879,8.893Z",
    transform: "translate(-105.355 -0.007)",
    fill: "#facca8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28629",
    "data-name": "Path 28629",
    d: "M198.887,68.855l6.7-.926,2.235,9.309-8.458.484Z",
    transform: "translate(-115.718 -0.007)",
    fill: "#f5f5f5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28630",
    "data-name": "Path 28630",
    d: "M249.107,67.1l-19.824-2.2-10.518-18.66a9.114,9.114,0,0,0-16.759,6.769l.061.232,17.68,25.8,33.058,1.63Z",
    transform: "translate(-163.525 -0.004)",
    fill: "#991f1f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28631",
    "data-name": "Path 28631",
    d: "M222.938,28.334l10.323.371c.63.023,2.338-6.77,2.562-8.179a3.846,3.846,0,0,1,4.012-3.112c.773.073,2.722-1.371,4.734-3.081a7.583,7.583,0,0,0-.575-12.087c-.115-.075-.227-.143-.338-.2a18.376,18.376,0,0,0-8.77-2.02,16.4,16.4,0,0,0-8,1.613c-4.342,2.333-6.652,7.43-6.855,12.355s1.376,9.739,3.167,14.331",
    transform: "translate(-176.317 0)",
    fill: "#1d1d26"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityReportsIcon);
export default __webpack_public_path__ + "static/media/ActivityReportsIcon.4ea9572cdc9fa8bcec952c67ed9abe4c.svg";
export { ForwardRef as ReactComponent };